import * as React from "react";
import { PropTypes } from "prop-types";
import classNames from "classnames";
import isObject from "lodash/isObject";

import ProductEducationAccordionMediaItem from "../product-education-accordion-media-item/product-education-accordion-media-item";
import IconByName from "../../icon-by-name/icon-by-name";
import { createEncodedKey } from "../../../utils/helpers";

const getIcon = (iconId, attributeType) => {
  const iconNames = {
    "responsible-down-standard": "icon-responsible-down-standard",
    "good-cashmere-standard": "icon-good-cashmere-standard"
  };

  if (iconId) {
    return <IconByName name={iconId} className="svg-icon" />;
  }

  if (attributeType && iconNames[attributeType]) {
    return (
      <IconByName
        name={iconNames[attributeType]}
        className="svg-icon product-education-accordions__attributeType-icon"
      />
    );
  }

  return null;
};

const AttributeList = ({ list }) => (
  <dl>
    <dt className="product-education-accordions__attributes__item__list">{`${list.title}: `}</dt>
    {list.items.map((listItem, index) => {
      const sep = index + 1 !== list.items.length ? ", " : "";
      return (
        <dd
          className="product-education-accordions__attributes__item__list"
          key={`product-education-accordions__attributes__item-${index + 1}`}
        >
          {`${listItem}${sep}`}
        </dd>
      );
    })}
  </dl>
);

const AttributeItem = ({ attribute, size }) => {
  const { iconId, list, text, attributeType } = attribute;
  const hasIcon =
    iconId ||
    attributeType === "responsible-down-standard" ||
    attributeType === "good-cashmere-standard";

  const attributeText =
    list && isObject(list) ? <AttributeList list={list} /> : text;

  const key = `product-education-accordions__attributes--${createEncodedKey(
    attribute
  )}`;

  return (
    <li
      key={key}
      className={classNames({
        "product-education-accordions__attributes__item": true,
        "product-education-accordions__attributes__item--with-bullet":
          size === "small" && !iconId,
        "product-education-accordions__attributes__item--with-icon": hasIcon
      })}
    >
      <span className="product-education-accordions__attributes__item__flex">
        {hasIcon && getIcon(iconId, attributeType)}
        {attributeText}
      </span>
    </li>
  );
};

const ProductEducationAccordionItem = ({
  accordionIndex,
  attributes,
  currentBreakpoint,
  media,
  size,
  title
}) => (
  <div className="product-education-accordions__panel wrapper container-fluid lll-grid">
    {!!title && (
      <div className="product-education-accordions__panel__title">{title}</div>
    )}
    {!!media.length && size === "large" && (
      <ProductEducationAccordionMediaItem
        accordionIndex={accordionIndex}
        media={media}
        currentBreakpoint={currentBreakpoint}
      />
    )}
    <ul
      className={classNames({
        "product-education-accordions__attributes": true,
        "product-education-accordions__attributes--with-media":
          !!media.length && size === "large"
      })}
    >
      {attributes.map((attribute) => (
        <AttributeItem key={attribute.id} attribute={attribute} size={size} />
      ))}
    </ul>
  </div>
);

ProductEducationAccordionItem.defaultProps = {
  accordionIndex: 0,
  attributes: [],
  media: [],
  size: "large",
  title: ""
};

ProductEducationAccordionItem.propTypes = {
  accordionIndex: PropTypes.number,
  attributes: PropTypes.arrayOf(PropTypes.object),
  currentBreakpoint: PropTypes.string.isRequired,
  media: PropTypes.arrayOf(PropTypes.object),
  size: PropTypes.string,
  title: PropTypes.string
};

export default ProductEducationAccordionItem;
